const ONE_THOUSAND = 1000;
const TEN_THOUSAND = 10000;

function getRandomInt(min: number, max: number) {
  const minInt = Math.ceil(min);
  const maxInt = Math.floor(max);
  return Math.floor(Math.random() * (maxInt - minInt + 1) + minInt);
}

const useKoreanUnitSeparators = (number: number) =>
  number >= TEN_THOUSAND
    ? `${number / TEN_THOUSAND}만`
    : number >= ONE_THOUSAND
    ? `${number / ONE_THOUSAND}천`
    : number;

function withPriceSeperator(price: number): string | undefined {
  if (typeof price !== 'number' || !Number.isFinite(price)) {
    // NaN, Infinity, -Infinity 제외
    return undefined;
  }
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function roundWithDecimal(
  price: number,
  devider = TEN_THOUSAND,
  decimalPlace = 1,
) {
  if (!devider) return 0;
  const devidedPrice = +`${price / devider}e+${decimalPlace}`;
  return +`${Math.round(devidedPrice)}e-${decimalPlace}`;
}

const makePercentFromRate = (rate: number) => {
  return Math.round(rate * 1000) / 10;
};

export {
  getRandomInt,
  makePercentFromRate,
  roundWithDecimal,
  useKoreanUnitSeparators,
  withPriceSeperator,
};
